import { CheckoutSession, getCheckoutSessionById, patchUpdateDownPayment } from '@nemuru-eng/js-api-client';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const useEditDownPayment = (checkoutSession: CheckoutSession) => {
  const { revalidate } = useCache(getCheckoutSessionById, { checkoutSessionId: checkoutSession.id });
  const { request, loading } = useRequest();
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  const editDownPayment = async (newDownPaymentValue: number) => {
    if (!checkoutSession) {
      return;
    }

    const clientSecret = await checkoutSessionEntity?.getClientSecret();
    if (!clientSecret) {
      return;
    }

    await request(patchUpdateDownPayment, {
      id: checkoutSession.id,
      downPayment: {
        currency: checkoutSession.downPayment?.amount.currency,
        amount: newDownPaymentValue,
      },
      clientSecret,
    });

    revalidate();
  };

  return {
    editDownPayment,
    loading,
  };
};
